import PropTypes from 'prop-types';
import OutlinedPillButton from '../shared/button/OutlinedPillButton';
import Text from '../Text';
import { DONATE } from '../../constants/localizations/profile';

const DonateButton = ({ text, url, className }) => (
  <a
    className={className}
    target="_blank"
    href={url}
    data-testid="profileDonate"
  >
    <OutlinedPillButton
      id="donateButton"
      label={text || <Text name={DONATE} />}
    />
  </a>
);

DonateButton.propTypes = {
  text: PropTypes.string,
  url: PropTypes.string,
  className: PropTypes.string,
};

export default DonateButton;
